import type { LocationDescriptor, Location } from 'history'
import type { LinkProps } from 'react-router-dom'

export type LinkTo =
  | LocationDescriptor<unknown>
  | ((location: Location<unknown>) => LocationDescriptor<unknown>)

export const isExternalLink = (to: LinkProps['to']) => {
  try {
    const path = typeof to === 'object' ? to.pathname || '' : typeof to === 'string' ? to || '' : ''
    const url = new URL(path, window.location.origin)
    const externalLink =
      url.hostname !== window.location.hostname || url.host !== window.location.host
    return { externalLink, path }
  } catch (err) {
    return { externalLink: false, path: '' }
  }
}

export const getPathString = (location: Location<unknown>, to?: LinkTo) => {
  const descriptor = typeof to === 'function' ? to(location) : to
  if (typeof descriptor === 'string') {
    return descriptor
  }
  return descriptor?.pathname
}
